import React from 'react';
import Button from './Button';

export default class ContactLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    return (
      <Button
        link
        bordered
        href={this.state.mounted ? 'mailto:me%40gauti.info' : '#'}
        title="Contact Gowtham Selvaraj"
      >
        Say Hello
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactLink.js